<template>
  <div class="page-wrap">
    <oHead></oHead>
    <animationWrap style="top: 0" @current="(newV)=>{this.currentModule = newV}">
      <div class="banner-slot">
        <Transition enter-active-class="animate__animated animate__slideInDown">
          <div class="banner" v-if="currentModule>0">
            <div>欢迎随时联系我们</div>
            <p>
              <span style='margin-right: 10px'>赋能环保水利</span><span>引领数智创新</span>
            </p>
          </div>
        </Transition>
      </div>
      <moduleWrap
        class="method-wrap"
        :active="currentModule>0"
        title="联系方式"
        :subTitleV="false"
        bgCol="#f7fafc"
      >
        <Transition enter-active-class="animate__animated animate__slideInLeft">
          <div class="method-inner" v-if="currentModule>0">
            <div class="method-item" v-for="(item,ind) in contactData" :key="ind">
              <img :src="item.icon" width="148" height="148" alt />
              <div>{{item.title}}</div>
              <span>{{item.content}}</span>
            </div>
          </div>
        </Transition>
        <Transition enter-active-class="animate__animated animate__slideInRight">
          <div class="com-map" v-if="currentModule>0">
            <div class="map-content" ref="map"></div>
          </div>
        </Transition>
      </moduleWrap>
      <moduleWrap
        class="consulting-wrap"
        :active="currentModule>1"
        title="产品咨询"
        :subTitleV="false"
        bgCol="#fff"
      >
        <div class="consulting-slot">
          <Transition enter-active-class="animate__animated animate__swing">
            <consulting v-if="currentModule>1"></consulting>
          </Transition>
        </div>
      </moduleWrap>
      <oFoot :active="currentModule>2"></oFoot>
    </animationWrap>
  </div>
</template>

<script>
import consulting from '@/components/consulting.vue'
import moduleWrap from '@/components/moduleWrap.vue'
import oHead from '@/components/header.vue'
import oFoot from '@/components/footer.vue'
import animationWrap from '@/components/animationWrap.vue'

export default {
  components: {
    oHead,
    moduleWrap,
    consulting,
    oFoot,
    animationWrap
  },
  data() {
    return {
      currentModule: 0,
      contactData: [
        {
          icon: '/img/icon_phone01@2x.png',
          title: '服务电话',
          content: '0591-87721622',
        },
        {
          icon: '/img/icon_address02@2x.png',
          title: '公司地址',
          content: '福州市闽侯县万福中心1号楼21层',
        },
        {
          icon: '/img/icon_mail02@2x.png',
          title: '邮箱',
          content: 'lxudong2@linewell.com',
        },
      ],
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.initMap()
    })
  },
  methods: {
    initMap() {
      let lng = 119.223231
      let lat = 26.046298
      var map = new BMapGL.Map(this.$refs.map)
      var point = new BMapGL.Point(lng, lat)
      var marker = new BMapGL.Marker(point) // 创建点
      var opts = {
          position: point, // 指定文本标注所在的地理位置
          offset: new BMapGL.Size(-110, -90) // 设置文本偏移量
      };
      // 创建文本标注对象
      var label = new BMapGL.Label('<span style="position:relative"> <i style="position: absolute; border: 8px solid transparent;border-top: 8px solid #fff;top: 33px;left: 83px;"></i><img src="/img/icon_address03@2x.png" width="16" height="16"> 福建万福信息技术有限公司</span>',opts)
      // 自定义文本标注样式
      label.setStyle({
        color: '#0b68bf',
        fontWeight: 'bold',
        borderColor: '#fff',
        padding: '0 18px',
        borderShadow: '0px 4px 25px 0px rgba(216,222,228,0.50)',
        fontSize: '14px',
        height: '50px',
        lineHeight: '50px',
        fontFamily: 'PingFang SC, PingFang SC-Medium',
      })
      map.addOverlay(label)
      map.centerAndZoom(point, 18)
      map.enableScrollWheelZoom(true)
      map.addOverlay(marker)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util.scss';
.banner-slot{
  width: 100%;
  height: 400px;
  background-image: url('../../public/img/banner06@2x.png');
  @include bgConfig;
}
.banner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  & > div {
    font-weight: bold;
    font-size: 40px;
    color: #ffffff;
  }
  p {
    margin-top: 16px;
    span {
      font-size: 16px;
      margin-right: 10px;
      color: #929caa; 
    }
  }
}
.method-wrap {
  padding-top: 63px;
  min-height: 1018px;
  .method-inner {
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: #333333;
    margin: 48px 0 64px;
    .method-item {
      text-align: center;
      width: 300px;
      div {
        font-size: 16px;
        color: #929caa;
        margin: 32px 0 8px;
      }
      span {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .com-map {
    width: 100%;
    height: 480px;
    padding: 24px;
    background: #fff;
    .map-content {
      width: 100%;
      height: 100%;
    }
  }
}
.consulting-wrap {
  padding-top: 63px;
  .consulting-slot {
    width: 100%;
    min-height: 500px;
    padding-top: 48px;
  }
}
</style>